import { BaseContext } from '../../../utils/basecontext';
import { UIComponentCSSStyle } from '../uicomponentcss';
import { FlashMessageToggleButtonGroupCSSStyleImpl } from './flashmessagetogglebuttongroupcss';
import { ToggleButtonGroupComponent, ToggleButtonGroupProps } from './togglebuttongroupcomponent';


export class FlashMessageToggleButtonGroupComponent extends ToggleButtonGroupComponent
{
    UNSAFE_componentWillReceiveProps(nextProps: ToggleButtonGroupProps)
    {
       
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new FlashMessageToggleButtonGroupCSSStyleImpl(applicationContext);
    }

}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/togglebuttongroup/flashmesasgetogglebuttongroupcomponent.tsx